// extracted by mini-css-extract-plugin
export default {"InputArea":"StringManipulation_InputArea__F7kGF","Actions":"StringManipulation_Actions__HGQXa","checkBox":"StringManipulation_checkBox__jm5kN"};